import { useState } from 'react'
import { PAGINATION_PER_PAGE_OPTIONS } from 'utils/config'

const initialPag = {
  currentPage: 1,
  nextPage: null,
  prevPage: null,
  total: 0,
  perPage: PAGINATION_PER_PAGE_OPTIONS[0],
}

export default (initialPagination = initialPag) => {
  const [pagination, setPagination] = useState(initialPagination)
  const [perPage, setPerPage] = useState(initialPag.perPage)
  const [currPage, setPage] = useState(initialPag.currentPage)

  const handlePerPage = (val) => {
    setPerPage(Number(val))
    setPage(1)
  }

  return {
    values: { ...pagination, currentPage: currPage, perPage },
    setPerPage: handlePerPage,
    setPage,
    setPagination,
  }
}
